import { Spinner } from 'react-bootstrap'

function SpinnerFullScreen() {
  return (
    <>
    <style type="text/css">
    {`.spinner-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
        }

        .spinner {
			width: 100px;
			height: 100px;
        }`}
    </style>
    <div className="spinner-container">
		<Spinner animation="border" role="status">
			<span className="visually-hidden">Loading...</span>
		</Spinner>
    </div>
    </>
    
  )
}

export default SpinnerFullScreen